/**
 * Statistics Service
 * Handles statistics and analytics API operations
 */

import apiClient from "./api";

class StatsService {
  /**
   * Get statistics overview
   * @param {Object} params - Filter parameters
   * @param {string} params.date_from - Start date (ISO format)
   * @param {string} params.date_to - End date (ISO format)
   * @returns {Promise<Object>} Statistics data
   */
  async getOverview(params = {}) {
    const response = await apiClient.get("/stats/overview", params);
    
    if (!response.success) {
      throw new Error(response.message || "Failed to fetch statistics");
    }
    
    return response.data;
  }

  /**
   * Get statistics by event
   * @param {Object} params - Filter parameters
   * @returns {Promise<Object>} Event statistics
   */
  async getByEvent(params = {}) {
    const overview = await this.getOverview(params);
    return overview.by_event || {};
  }

  /**
   * Get statistics by manager
   * @param {Object} params - Filter parameters
   * @returns {Promise<Array>} Manager statistics
   */
  async getByManager(params = {}) {
    const overview = await this.getOverview(params);
    return overview.by_manager || [];
  }
}

export const statsService = new StatsService();
export default statsService;
